export default class PaymentSuccess{
  public id: string = '';

  public inspection: string = '';

  public protocol: string = '';

  public number: string = '';

  public url: string = '';

  constructor(data: any = {}) {
    this.id = data.id || '';
    this.inspection = data.inspection || '';
    this.protocol = data.protocol || '';
    this.number = data.number || '';
    this.url = data.url || '';
  }
}
